import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CityService } from '../../services/city.service';
import { CommentService } from '../../services/comment.service';
import { CRMService } from '../../services/crm.service';
import { ERPService } from '../../services/erp.service';
import { NotificationService } from '../../services/notification.service';
import { RecordLockService } from '../../services/recordlock.service';
import { UtilService } from '../../services/util.service';
import {
    City
    , Comment
    , Customer
    , CustomerInitiative
    , CustomerInitiativeMap
    , CustomerLookup
    , Industry
    , RecordLock
    , RecordLockType
    , RecordType
    , SearchCustomer
    , SearchRecordLock
} from '../../models/models';

@Component({
    selector: 'customer-form',
    templateUrl: './customer-form.component.html',
    standalone: false
})
export class CustomerForm implements OnInit, OnChanges {
    @Input() customerID: number = 0;
    @Input() pageType: string = "";
    @Output() customerSaved: EventEmitter<Customer> = new EventEmitter<Customer>();

    //public selectedCustomerID: number = 0;
    public selectedCustomer: Customer = {} as Customer;
    public parentCustomer: SearchCustomer = {} as SearchCustomer;
    private parentCustomerID: number = 0;
    public isParent: boolean = false;
    public isSaving: boolean = false;

    public initiativeList: CustomerInitiative[] = [];
    public initiativeIDList: number[] = [];
    public industries: Industry[] = [];
    private customerCity: City = {} as City;
    public defaultCustomerCity: string = "";
    public crmNotes: Comment = {} as Comment;
    public operationalNotes: Comment = {} as Comment;
    //public customerForm: UntypedFormGroup = new UntypedFormGroup({});
    public submitted: boolean = false;
    public phoneMask: string = "(999) 000-0000";
    public isCRMAdmin: boolean = false;

    private isLockEnabled: boolean = false;
    public isLocked: boolean = false;
    private recordLock: RecordLock = {} as RecordLock;
    private recordTypes: RecordType[] = [];
    private recordLockTypes: RecordLockType[] = [];
    public searchRecordLock: SearchRecordLock = {} as SearchRecordLock;

    private usPhoneMask: string = '(999) 000-0000';
    private mexicoPhoneMask: string = '99999-999-999-9999';

    public customerForm: UntypedFormGroup = new UntypedFormGroup({
        cityCtrl: new UntypedFormControl(''),
        parentCustomerCtrl: new UntypedFormControl('')
    });

    constructor(private cityService: CityService, private commentService: CommentService,
        private crmService: CRMService, private erpService: ERPService,
        private notificationService: NotificationService, private recordLockService: RecordLockService,
        private utilService: UtilService, private router: Router) {
    }

    ngOnInit() {
        this.getCustomerInitiatives();
        this.getIndustries();
        this.isCRMAdmin = this.getIsCRMAdmin();
        this.getRecordLockTypes();
        this.getRecordTypes();
        //console.log("ngOnInit", this.customerID, this.selectedCustomer.parentCustomerId, this.selectedCustomer.parent, this.selectedCustomer);
    }

    ngOnChanges(changes: SimpleChanges) {
        this.buildForm();
        //if (changes.customerID == null || changes.customerID.currentValue == null || changes.customerID.currentValue.toString() == '') return;

        //this.selectedCustomerID = parseInt(changes.customerID.currentValue);
        this.getCustomer();
        //console.log("ngOnChanges", this.customerID, this.selectedCustomer.parentCustomerId, this.selectedCustomer.parent, this.selectedCustomer, changes);
    }

    private buildForm() {
        this.selectedCustomer = {} as Customer;
        this.parentCustomer = {} as SearchCustomer;
        this.parentCustomerID = 0;
        this.customerCity = {} as City;
        this.defaultCustomerCity = "";
        this.crmNotes = {} as Comment;
        this.operationalNotes = {} as Comment;

        //this.customerForm = this.formBuilder.group({
        //    //nameCtrl: ['', Validators.required],
        //    //billToIndCtrl: [false],
        //    //shipperIndCtrl: [false],
        //    //consigneeIndCtrl: [false],
        //    //activeIndCtrl: [true],
        //    //retiredIndCtrl: [false],
        //    //addressOneCtrl: ['', Validators.required],
        //    //addressTwoCtrl: [''],
        //    cityCtrl: ['', Validators.required],
        //    //parentCustomerCtrl: [],
        //    initiativesCtrl: [''],
        //    //freightCtrl: [0],
        //    //creditLimitAmountCtrl: [0],
        //    crmNotesCtrl: [''],
        //    operationalNotesCtrl: ['']
        //    //isParentCtrl: [false],
        //    //revenueBaseLineCtrl: [0]
        //});
    }

    private getIsCRMAdmin() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        //console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('CRM Admin') > -1) return true;
        }

        return false;
    }

    private getCustomerInitiatives() {
        this.crmService.getCustomerInitiatives().subscribe(result => {
            this.initiativeList = result;
        });
    }

    private getIndustries() {
        this.crmService.getIndustries().subscribe(result => {
            this.industries = result;
        })
    }

    private getCustomer() {
        //if (this.selectedCustomerID < 1) return;

        this.utilService.isLoading = true;
        this.crmService.getCustomerById(this.customerID).subscribe(result => {
            this.utilService.isLoading = false;
            this.selectedCustomer = result;
            this.isParent = this.selectedCustomer.parent == "Y" ? true : false;
            this.getCity();
            if (this.selectedCustomer.parentCustomerId > 0) {
                this.parentCustomerID = this.selectedCustomer.parentCustomerId;
                this.getParentCustomer(this.selectedCustomer.parentCustomerId);
            }
            else {
                this.parentCustomer = {} as SearchCustomer;
                this.parentCustomerID = 0;
            }
            //this.setCustomerFormValues();
            this.getComments();
            if (this.isLockEnabled) {
                this.handleRecordLock(this.customerID);
            }
            //console.log("getCustomer", this.customerID, this.selectedCustomer.parentCustomerId, this.selectedCustomer.parent, this.selectedCustomer);
        });

        this.crmService.getInitiativeMapsByCustomerId(this.customerID).subscribe(result => {
            let initiativeIds: number[] = [];

            result.forEach(i => {
                initiativeIds.push(i.customerInitiativeID);
            });

            this.initiativeIDList = initiativeIds;

            //this.customerForm.controls['initiativesCtrl'].setValue(initiativeIds);
        });
    }

    public removeParent() {
        this.parentCustomer = {} as SearchCustomer;
        this.parentCustomerID = 0;
        this.selectedCustomer.parentCustomerId = 0;
    }

    public onCustomerChange(evt: any, ctrl: string) {
        var selectedCustomer = this.customerForm.controls[ctrl].value as CustomerLookup;

        if (ctrl == "parentCustomerCtrl") {
            this.parentCustomer = {} as SearchCustomer;
            if (!isNaN(evt) && evt != null) {
                this.parentCustomerID = evt;
            }
            else {
                this.parentCustomerID = selectedCustomer.customerID;
            }
            if (this.parentCustomerID > 0) {
                this.getParentCustomer(this.parentCustomerID);
            }
        }
        //console.log("onCustomerChange", evt, ctrl, this.parentCustomerID, this.parentCustomer);
    }

    private getParentCustomer(customerID: number) {
        this.utilService.isLoading = true;
        this.crmService.getSearchCustomerByID(customerID).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.parentCustomer = result.resultCollection[0];
                this.selectedCustomer.parentCustomerId = this.parentCustomer.customerID;
            }
            //console.log("getParentCustomer", customerID, this.parentCustomerID, this.selectedCustomer.parentCustomerId, this.parentCustomer);
        });
    }

    private getCity() {
        this.cityService.getCityByID(this.selectedCustomer.cityId).subscribe(result => {
            if (result.resultCollection.length > 0) {
                var city = result.resultCollection[0];
                this.defaultCustomerCity = city.cityST;
                this.customerCity = result.resultCollection[0];
                //console.log("getCity", this.selectedCustomer.cityId, this.customerCity, result);
            }
            else {
                this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
            }
        });
    }

    public citySTChanged(evt: any) {
        var cityID = evt;
        this.cityService.getCityByID(cityID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.customerCity = result.resultCollection[0];
                this.selectedCustomer.cityId = cityID;
                this.selectedCustomer.apiZip = this.customerCity.zip;
                //console.log("cityZipChanged:customerCity", cityID, this.customerCity, result);
            }
            else {
                this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
            }
        });
    }

    //public industryChanged() {
    //    if (this.customer.industryId == null || this.customer.industryId < 1) return;

    //    this.saveCustomer();
    //}

    //private setCustomerFormValues() {
    //    if (this.selectedCustomer == null || this.selectedCustomer.customerId == null || this.selectedCustomer.customerId < 1) return;

    //    this.customerForm.controls['nameCtrl'].setValue(this.selectedCustomer.name);
    //    this.customerForm.controls['billToIndCtrl'].setValue(this.selectedCustomer.billToInd);
    //    this.customerForm.controls['shipperIndCtrl'].setValue(this.selectedCustomer.shipperInd);
    //    this.customerForm.controls['consigneeIndCtrl'].setValue(this.selectedCustomer.consigneeInd);
    //    this.customerForm.controls['activeIndCtrl'].setValue(this.selectedCustomer.activeInd);
    //    this.customerForm.controls['retiredIndCtrl'].setValue(this.selectedCustomer.retiredInd);
    //    this.customerForm.controls['addressOneCtrl'].setValue(this.selectedCustomer.address1);
    //    this.customerForm.controls['addressTwoCtrl'].setValue(this.selectedCustomer.address2);
    //    this.customerForm.controls['freightCtrl'].setValue(this.selectedCustomer.freightSpend);
    //    this.customerForm.controls['creditLimitAmountCtrl'].setValue(this.selectedCustomer.creditLimitAmount);
    //    this.customerForm.controls['revenueBaseLineCtrl'].setValue(this.selectedCustomer.monthlyNetRevenueBaseLine);

    //    if (this.selectedCustomer.parent == 'Y') this.customerForm.controls['isParentCtrl'].setValue(true);
    //}

    public saveCustomer(isERPSync: boolean) {
        this.submitted = true;

        if (this.customerForm.valid) {
            var employeeId = parseInt(localStorage.getItem('EmployeeId')!);
            //var customer = {
            //    customerId: this.customerID,
            //    name: this.customerForm.controls['nameCtrl'].value,
            //    salesEmployeeID: this.selectedCustomer.salesEmployeeID,
            //    opsRepId: this.selectedCustomer.opsRepId,
            //    accountRepId: this.selectedCustomer.accountRepId,
            //    customerStatusId: this.selectedCustomer.customerStatusId,
            //    address1: this.customerForm.controls['addressOneCtrl'].value,
            //    cityId: this.customerCity.cityId,
            //    apiZip: this.customerCity.zip,
            //    billToInd: this.customerForm.controls['billToIndCtrl'].value,
            //    shipperInd: this.customerForm.controls['shipperIndCtrl'].value,
            //    consigneeInd: this.customerForm.controls['consigneeIndCtrl'].value,
            //    industryId: this.selectedCustomer.industryId,
            //    activeInd: this.customerForm.controls['activeIndCtrl'].value,
            //    retiredInd: this.customerForm.controls['retiredIndCtrl'].value,
            //    freightSpend: this.customerForm.controls['freightCtrl'].value,
            //    creditLimitAmount: this.customerForm.controls['creditLimitAmountCtrl'].value,
            //    parent: this.customerForm.controls['isParentCtrl'].value == true ? 'Y' : 'N',
            //    parentCustomerId: this.parentCustomerID,
            //    monthlyNetRevenueBaseLine: this.customerForm.controls['revenueBaseLineCtrl'].value,
            //    website: this.selectedCustomer.website
            //} as Customer;
            this.selectedCustomer.parent = this.isParent == true ? 'Y' : 'N';
            this.selectedCustomer.parentCustomerId = this.parentCustomerID;
            this.selectedCustomer.cityId = this.customerCity.cityID;
            this.selectedCustomer.apiZip = this.customerCity.zip;

            if (this.crmNotes.commentId && this.crmNotes.commentId > 0) {
                this.selectedCustomer.commentId = this.crmNotes.commentId;
            }
            if (this.operationalNotes.commentId && this.operationalNotes.commentId > 0) {
                this.selectedCustomer.extraCommentId = this.operationalNotes.commentId;
            }

            if (this.selectedCustomer.customerID < 1) {
                this.selectedCustomer.createDate = new Date();
                this.selectedCustomer.createEmployeeId = employeeId;
            } else {
                this.selectedCustomer.lastRevisedEmployeeId = employeeId;
            }

            // console.log("SaveCustomer", this.selectedCustomer);
            // return;

            this.utilService.isLoading = true;
            this.isSaving = true;
            this.crmService.saveCustomer(this.selectedCustomer).subscribe(result => {
                this.isSaving = false;
                this.utilService.isLoading = false;
                var savedCustomer = result;

                if (isERPSync) {
                    this.syncERPCustomer(savedCustomer.customerID);
                }

                if (savedCustomer.customerID > 0) {
                    let maps: CustomerInitiativeMap[] = [];

                    //if (this.customerForm.controls['initiativesCtrl'].value != '') {
                    if (this.initiativeIDList.length > 0) {
                        //var inits = this.customerForm.controls['initiativesCtrl'].value as number[];
                        this.initiativeIDList.forEach(i => {
                            var map = {
                                customerID: savedCustomer.customerID,
                                customerInitiativeID: i,
                                customerInitiativeMapID: 0
                            } as CustomerInitiativeMap;

                            maps.push(map);
                        });

                        this.isSaving = true;
                        this.utilService.isLoading = true;
                        this.crmService.saveCustomerInitiativeMaps(maps).subscribe(result => {
                            this.isSaving = false;
                            this.utilService.isLoading = false;
                            console.log("saveCustomerInitiativeMaps", result);
                        });
                    } else {
                        this.isSaving = true;
                        this.utilService.isLoading = true;
                        this.crmService.deleteCustomerInitiativeMaps(savedCustomer.customerID).subscribe(result => {
                            this.isSaving = false;
                            this.utilService.isLoading = false;
                            console.log("deleteCustomerInitiativeMaps", result);
                        });
                    }

                    //this.clearRecordLock();
                    this.notificationService.showSuccess("Successfully saved customer: " + savedCustomer.customerCode, "SUCCESS: Save Customer");
                } else {
                    this.submitted = false;
                    this.notificationService.showError("Error saving customer", "ERROR: Save Customer");
                }
            });
        }
    }

    private getComments() {
        if (this.selectedCustomer != null) {
            if (this.selectedCustomer.commentId > 0) {
                this.commentService.getCommentById(this.selectedCustomer.commentId).subscribe(result => {
                    if (result.commentText == null) {
                        result.commentText = "";
                    }
                    //this.customerForm.controls['crmNotesCtrl'].setValue(result.commentText);
                    this.crmNotes = result;
                });
            } else {
                //this.customerForm.controls['crmNotesCtrl'].setValue("");
                this.crmNotes = {} as Comment;
            }

            if (this.selectedCustomer.extraCommentId > 0) {
                this.commentService.getCommentById(this.selectedCustomer.extraCommentId).subscribe(result => {
                    if (result.commentText == null) {
                        result.commentText = "";
                    }
                    //this.customerForm.controls['operationalNotesCtrl'].setValue(result.commentText);
                    this.operationalNotes = result;
                });
            } else {
                //this.customerForm.controls['operationalNotesCtrl'].setValue("");
                this.operationalNotes = {} as Comment;
            }
        }
    }

    public saveComment(comment: Comment, commentType: string) {
        if (comment == null || comment.commentText == undefined) {
            return;
        }
        
        if (comment.commentText.length < 1) {
            comment.commentText = "-";
        }

        this.utilService.isLoading = true;
        this.commentService.saveComment(comment).subscribe(result => {
            this.utilService.isLoading = false;
            var ok = result;
            if (commentType == "crmNotes") {
                this.selectedCustomer.commentId = result.commentId;
                this.crmService.saveCustomerComments(this.selectedCustomer.customerID, this.selectedCustomer.commentId, this.selectedCustomer.extraCommentId).subscribe(resultComment => {
                    console.log("saveCustomerComments", result);
                });
                this.crmNotes = Object.assign({}, result);
            }
            else if (commentType == "operationalNotes") {
                this.selectedCustomer.extraCommentId = result.commentId;
                this.crmService.saveCustomerComments(this.selectedCustomer.customerID, this.selectedCustomer.commentId, this.selectedCustomer.extraCommentId).subscribe(resultComment => {
                    console.log("saveCustomerComments", result);
                });
                this.operationalNotes = Object.assign({}, result);
            }
        });
    }

    public syncERPCustomer(customerID) {
        this.notificationService.showInfo("Updating ERP Customer ...", "ERP Update");
        this.utilService.isLoading = true;
        this.erpService.updateERPCustomer(customerID, "TMW").subscribe(result => {
            this.utilService.isLoading = false;
            var ok = result;
            if (result.message != "OK") {
                this.notificationService.showError("Error updating ERP: " + result.message, "ERROR: ERP Update");
            }
            else {
                this.notificationService.showInfo("ERP Update Complete", "ERP Update");
            }
        });
    }

    //public cancelOverride() {
    //    this.isEditStop = false;
    //    this.isAddStop = false;
    //    this.isShiftStop = false;
    //    this.addStopPlace = "";
    //    this.orderStopID = 0;
    //    this.newStop = {} as AddOrderStop;
    //    this.isLocked = false;
    //}

    private getRecordLockTypes() {
        this.recordLockService.getRecordLockTypes().subscribe(result => {
            this.recordLockTypes = result.resultCollection;
        })
    }

    private getRecordTypes() {
        this.recordLockService.getRecordTypes().subscribe(result => {
            this.recordTypes = result.resultCollection;
        });
    }

    private clearRecordLock() {
        var recordTypeID = this.recordTypes.find(r => r.recordTypeName == "Customer")!.recordTypeID;
        var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
        var recordID = this.customerID;

        // Clear all locks for this employee before handling the current record
        this.recordLockService.clearRecordLockByRecordTypeEmployeeRecord(recordTypeID, employeeID, recordID).subscribe(result => {
            var col = result.resultCollection;
            this.isLocked = false;
        });
        //this.recordLockService.clearRecordLock("QuoteOrder", recordID, this.recordLockSource);
        //this.recordLockService.clearRecordLock(this.recordLockService.recordLock.recordLockID);
    }

    private handleRecordLock(id: number) {
        //var recordTypeID = this.recordTypes.find(r => r.recordTypeName == "Customer")!.recordTypeID;
        //var employeeID = parseInt(localStorage.getItem('EmployeeId')!);

        //console.log("handleRecordLock", id, actionType, recordTypeID, employeeID);

        // Clear all locks for this employee before handling the current record
        //    this.recordLockService.clearRecordLockByRecordTypeEmployee(recordTypeID, employeeID).subscribe(clearResult => {
        //        var col = clearResult.resultCollection;
        //    });
        // Handle the lock for this record
        this.recordLockService.getSearchRecordLockByRecordTypeNameRecordID("Customer", id).subscribe(result => {
            var canLock = false;
            if (result.resultCollection.length > 0) {
                //console.log("handleRecordLock:searchRecordLock", employeeID, id, result);
                var searchCol: SearchRecordLock[] = Object.assign([], result.resultCollection);
                searchCol = searchCol.filter(t => t.releasedByEmployeeID == null);
                this.searchRecordLock = searchCol[0];
                if (this.searchRecordLock != null) {
                    if (this.searchRecordLock.recordLockTypeName == "Unlocked") {
                        canLock = true;
                    }
                    this.recordLockService.getRecordLockByID(this.searchRecordLock.recordLockID).subscribe(resp => {
                        this.recordLock = resp.resultCollection[0];
                    });
                }
                else {
                    canLock = true;
                }
            }
            else {
                canLock = true;
            }
            if (canLock) {
                this.setRecordLock("Customer", id);
            }
            if (canLock || this.searchRecordLock == undefined) {
                this.isLocked = false;
            }
            else {
                this.isLocked = true;
            }
        });
    }

    private setRecordLock(type: string, id: number) {
        var lockSource: string = this.pageType + ": Edit Customer";

        var recordLockType = this.recordLockTypes.find(r => r.recordLockTypeName == "Overridable");
        if (this.searchRecordLock != null && this.searchRecordLock.recordLockID) {
            // Update existing Unlocked record
            this.recordLock = {
                recordLockID: this.searchRecordLock.recordLockID,
                recordLockTypeID: recordLockType!.recordLockTypeID,
                recordTypeID: this.searchRecordLock.recordTypeID,
                recordID: id,
                checkedOutByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                dateCheckedOut: this.utilService.getDateAsUTC(new Date()),
                lockSource: lockSource
                //releasedByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                //dateReleased: new Date()
            }
        }
        else {
            // Create new lock if not found
            var recordType = this.recordTypes.find(r => r.recordTypeName == type);
            if (recordLockType != null && recordType != null) {
                this.recordLock = {
                    recordLockID: 0,
                    recordLockTypeID: recordLockType.recordLockTypeID,
                    recordTypeID: recordType.recordTypeID,
                    recordID: id,
                    checkedOutByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                    dateCheckedOut: this.utilService.getDateAsUTC(new Date()),
                    lockSource: lockSource
                    //releasedByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                    //dateReleased: new Date()
                }
            }
            //console.log("setRecordLock:null", id, type, recordLockType, recordType);
        }

        //console.log("setRecordLock", id, type, this.recordTypes, this.recordLock, this.searchRecordLock);

        this.recordLockService.saveRecordLock(this.recordLock).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.recordLock = result.resultCollection[0];
                //this.handleRecordLock(id);
            }
            else {
                // Failed to acquire lock (eg. two people clicked at same time)
                //this.handleRecordLock(id);
            }
        });
    }

    public overrideRecordLock(id: number) {
        //console.log("overrideRecordLock", id, this.recordLockAction, this.recordLock);
        if (this.recordLock && this.recordLock.recordID == id) {
            this.recordLock.recordLockTypeID = this.recordLockTypes.find(r => r.recordLockTypeName == "Overridable")!.recordLockTypeID;
            this.recordLock.checkedOutByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.recordLock.dateCheckedOut = this.utilService.getDateAsUTC(new Date());
            this.recordLock.releasedByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.recordLock.dateReleased = this.utilService.getDateAsUTC(new Date());

            this.recordLockService.saveRecordLock(this.recordLock).subscribe(result => {
                //console.log("overrideRecordLock", id, result, this.recordLock);
                if (result.resultCollection.length > 0) {
                    this.recordLock = result.resultCollection[0];
                    //this.handleRecordLock(id);
                    this.isLocked = false;
                    //this.continueRecordLockAction();
                }
            });
        }
    }
}
